/** @license mt-block-editor-block-oembed

Copyright (c) 2020 Six Apart Ltd.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import "./i18n";
import Oembed from "./Block/Oembed";

window.MTBlockEditor.registerBlockType(Oembed);
